import React from "react";
import { Entity } from "@common/types/entity";
import { ConsolidationGroupResponse } from "@common/schemas/domains/accounting/consolidation.schema";
import {
    ConsolidationBasisSelector,
    UpdateGroupConfigCallbacks,
    UpdateGroupConfigParams,
} from "./ConsolidationBasisSelector";
import { PaneSection } from "./PaneSection";

interface EntityPaneConsolidationSectionProps {
    workspaceId: string;
    group: ConsolidationGroupResponse;
    entitiesByUuid: Map<string, Entity>;
    isUpdatingGroupConfig: boolean;
    onUpdateGroupConfig: (
        params: UpdateGroupConfigParams,
        callbacks?: UpdateGroupConfigCallbacks,
    ) => void;
}

/**
 * Ledger-basis control for the consolidation group pane.
 */
export const EntityPaneConsolidationSection: React.FC<
    EntityPaneConsolidationSectionProps
> = ({
    workspaceId,
    group,
    entitiesByUuid,
    isUpdatingGroupConfig,
    onUpdateGroupConfig,
}) => (
    <PaneSection title="Ledger basis" defaultExpanded>
        <ConsolidationBasisSelector
            workspaceId={workspaceId}
            group={group}
            entitiesByUuid={entitiesByUuid}
            isUpdating={isUpdatingGroupConfig}
            onUpdateGroupConfig={onUpdateGroupConfig}
        />
    </PaneSection>
);
